import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'

import { useLocale } from '@/context/localeContext'

import { CHECKOUT_GB, CHECKOUT_US } from '@/lib/checkout/types'
import { isInLocalisedPath } from '@/lib/utils/localisationUtils'

import { GeoContext } from '../../context/geoContext'
import { getFirstParamValue } from '../utils/queryParams'

export const DAILY_30_CHECKOUT_COUNTRY_ALLOW_LIST: string[] =
  process.env.NEXT_PUBLIC_D30_PRODUCT_AVAILABLE_IN_US === 'true' ? [CHECKOUT_GB, CHECKOUT_US] : [CHECKOUT_GB]

type UseD30CheckoutCountryType = {
  isReady: boolean
  isValidD30Country: boolean
  country: string
}

export const useD30CheckoutCountry = (): UseD30CheckoutCountryType => {
  const router = useRouter()
  const { country: geoCountry } = useContext(GeoContext)
  const { currentLocale } = useLocale()

  const [isValidD30Country, setIsValidD30Country] = useState(false)
  const [isReady, setIsReady] = useState(false)
  const [country, setCountry] = useState<string>('')

  useEffect(() => {
    if (!router.isReady) {
      return
    }

    const queryCountry = (router.query.country as string | undefined)?.toUpperCase()
    const pathCountry = isInLocalisedPath(router.asPath)
      ? currentLocale === 'en-us'
        ? CHECKOUT_US
        : CHECKOUT_GB
      : null

    const resolvedCountry = pathCountry ?? queryCountry ?? geoCountry

    if (resolvedCountry.length) {
      const isGeoCountryValid =
        DAILY_30_CHECKOUT_COUNTRY_ALLOW_LIST.includes(resolvedCountry) ||
        (resolvedCountry === CHECKOUT_US && getFirstParamValue(router.query, 'd30_us_test') === 'true')
      setIsValidD30Country(isGeoCountryValid)
      setCountry(resolvedCountry)
      setIsReady(true)
    }
  }, [geoCountry, router.query, router.isReady])

  return {
    isReady,
    isValidD30Country,
    country,
  }
}
